var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParking2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.7792 5.8125H19.2215C11.8282 5.8125 5.8125 11.8278 5.8125 19.2215V73.7792C5.8125 81.1726 11.8278 87.1883 19.2215 87.1883H73.7792C81.1726 87.1883 87.1883 81.173 87.1883 73.7792V19.2215C87.1883 11.8282 81.173 5.8125 73.7792 5.8125ZM82.8289 73.7785C82.8289 78.7678 78.7695 82.8281 73.7792 82.8281H19.2215C14.2312 82.8281 10.1719 78.7681 10.1719 73.7785V19.2208C10.1719 14.2314 14.2312 10.1711 19.2215 10.1711H73.7792C78.7695 10.1711 82.8289 14.2311 82.8289 19.2208V73.7785Z",
    fill: "#374336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7032 18.4055H24.5684V74.5945H41.3719V55.869H49.7032C60.0316 55.869 68.4349 47.4664 68.4349 37.1372C68.4349 26.808 60.0316 18.4055 49.7032 18.4055ZM49.7032 51.5096H37.0125V70.2351H28.9277V22.7648H49.7032C57.6275 22.7648 64.0755 29.2116 64.0755 37.1372C64.0755 45.0628 57.6279 51.5096 49.7032 51.5096Z",
    fill: "#374336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8639 28.675H37.2539V45.7196H46.8639C51.5633 45.7196 55.3858 41.8966 55.3858 37.1969C55.3858 32.4984 51.5629 28.675 46.8639 28.675ZM46.8639 41.3602H41.6133V33.0344H46.8639C49.1592 33.0344 51.0268 34.902 51.0268 37.1963C51.0268 39.4923 49.1592 41.3602 46.8639 41.3602Z",
    fill: "#374336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking2);
export default __webpack_public_path__ + "static/media/parking2.0f463686.svg";
export { ForwardRef as ReactComponent };